import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss'
})
export class NewsComponent {
  isMobile: boolean = false;
  windowSize: number = 0;
  isRender: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (isPlatformBrowser(this._platformId)) {
      const windowSize = window.innerWidth;
      this.isMobile = windowSize <= 1024 ? true : false;
    }
  }


  items = [

    {
      title: 'news.news_1',
      desc: 'news.news_1_desc',
      date: "news.news_1_date",
      img: "/assets/images/webp/news-2.webp",
      link: "https://markets.businessinsider.com/news/currencies/qxmp-labs-announces-activation-of-rwa-liquidity-architecture-and-1-1-trillion-on-chain-asset-registration-1035756227"

    },
    {
      title: 'news.news_2',
      desc: 'news.news_2_desc',
      date: "news.news_2_date",
      img: "/assets/images/webp/news-3.webp",
      link: "https://www.tradingview.com/news/chainwire:e3d2e6844094b:0-qxmp-labs-announces-activation-of-rwa-liquidity-architecture-and-1-1-trillion-on-chain-asset-registration/"
    },
    {
      title: 'news.news_3',
      desc: 'news.news_3_desc',
      date: "news.news_3_date",
      img: "/assets/images/webp/news-4.webp",
      link: "https://www.cryptopolitan.com/qxmp-labs-announces-activation-of-rwa-liquidity-architecture-and-1-1-trillion-on-chain-asset-registration/"

    },
    {
      title: 'news.news_4',
      desc: 'news.news_4_desc',
      date: "news.news_4_date",
      img: "/assets/images/webp/news-5.webp",
      link: "https://coincodex.com/article/80875/qxmp-labs-announces-activation-of-rwa-liquidity-architecture-and-11-trillion-on-chain-asset-registration/"

    },

  ];

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile = this.windowSize <= 1024;
      this.isRender = true;
    }
  }

  openNewsUrl(link: string): void {
    if (isPlatformBrowser(this._platformId)) {
      window.open(link, '_blank');
    }
  }
}
